// extracted by mini-css-extract-plugin
module.exports = {"richtext":"src-containers-Form-SimplifiedBuilder-Questions-RichTextComponent___richtext"};